export const GET_WORKER_FRIEND_LINK_PATH = "/agentprofile/myfriendlink";
